exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_nHndar5frZcGwHVQ_1s4L {\n  margin: 45px 40px 20px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.IA_AttachmentsAttachment_1ycwG15GPQiMsTDA0Tgi6Z {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_1HcazWV16iwLAwzH_WoKzA {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_nHndar5frZcGwHVQ_1s4L",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_1ycwG15GPQiMsTDA0Tgi6Z",
	"IA_AttachmentsLink": "IA_AttachmentsLink_1HcazWV16iwLAwzH_WoKzA"
};